import css from "styled-jsx/css";
import { BASE_TEMPLATE_ROOT } from "constants/z-index";
import { LAYER_ONE } from "constants/z-index";
import { LARGE_SCREEN_MIN_WIDTH } from "constants/vp-sizes";

export default css.global`
  .accessibility-menu-wrapper {
    position: relative;
    z-index: ${BASE_TEMPLATE_ROOT + 1};
  }

  .template-content-wrapper {
    position: relative;
    z-index: ${BASE_TEMPLATE_ROOT};

    &.with-background-color {
      background-color: white;
    }
    .live-board-open-button-wrapper {
      position: fixed;
      top: 60vh;
      right: 0;
      z-index: ${LAYER_ONE};
      padding-left: 20px;
      @media (max-width: ${LARGE_SCREEN_MIN_WIDTH}) {
        top: 70vh;
      }
      .x-button-wrapper {
        display: none;
      }
      &:hover {
        .x-button-wrapper {
          display: unset;
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
`;
